import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import { RequestStatusBadge } from "../../badge/RequestStatusBadge";
import { SuppliesRequestStatus } from "@/constants/entity-status";

interface Props {
  fechaEntrega?: string;
  titularCuenta?: string;
  destino?: string;
  kmDistancia?: number;
  contacto?: string;
  estadoDescripcion?: string;
}

export const FertSlotRequestMainData = ({
  fechaEntrega,
  titularCuenta,
  destino,
  kmDistancia,
  contacto,
  estadoDescripcion,
}: Props) => {
  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={18}>
      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="10px"
            textTransform="uppercase"
            paddingX="24px"
            fontWeight={700}
          >
            Detalle
          </Text>

          <Grid templateColumns="repeat(2, 1fr)">
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-title-label">Fecha de entrega:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-value-label">
                {fechaEntrega ? dayjs(fechaEntrega).format("DD/MM/YYYY") : "-"}
              </Text>
            </GridItem>

            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Cuenta:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-value-label">{titularCuenta ?? "-"}</Text>
            </GridItem>

            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Destino:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-value-label">{destino ?? "-"}</Text>
            </GridItem>
          </Grid>
        </Flex>
      </GridItem>

      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="16px"
            textTransform="uppercase"
            paddingX="24px"
            fontWeight={700}
            visibility="hidden"
          >
            -
          </Text>

          <Grid templateColumns="repeat(2, 1fr)">
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-title-label">Km de distancia:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-value-label">{new Intl.NumberFormat("es-AR").format(
                    kmDistancia ?? 0,
                  )}</Text>
            </GridItem>

            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Contacto:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-value-label">{contacto ?? "-"}</Text>
            </GridItem>

            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Estado:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text as="span" className="account-value-label">
                <RequestStatusBadge
                  status={estadoDescripcion as SuppliesRequestStatus}
                />
              </Text>
            </GridItem>
          </Grid>
        </Flex>
      </GridItem>
    </Grid>
  );
};

